import { getToken } from 'data/auth/utils'
import { EntityId } from 'entities-next/common'
import { createApiHandler, CreateApiHandlerConfig } from 'services-next/api'
import { createEntityParser, getUrlWithPathParams } from 'utils-next/api'

import { parseApiCorporate } from './corporate.config'
import { ApiCorporateData, Corporate, CorporateStatus } from './corporate.types'
import { PaginationOptions } from '../../utils-next/types'
import { PagedResult } from '../../utils/pagedResult'

export type CorporateListFilters = {
  id?: EntityId
  name?: string
  status?: CorporateStatus
}

const CORPORATES_ENDPOINT_PATH = 'admin/corporates'

export function getApiCorporateHandlers(customToken?: string, config: Omit<CreateApiHandlerConfig, 'baseUrl'> = {}) {
  const token = customToken || getToken() || undefined
  const transformResponse = createEntityParser(parseApiCorporate)
  const { callApi } = createApiHandler(token, { ...config, transformResponse })

  async function apiGetCorporate(id: EntityId): Promise<Corporate> {
    return callApi<Corporate>({
      method: 'GET',
      url: getUrlWithPathParams(CORPORATES_ENDPOINT_PATH, id),
    })
  }

  async function apiGetCorporateList(
    filters: CorporateListFilters,
    paginationOptions: PaginationOptions
  ): Promise<PagedResult<Corporate>> {
    const page = Number(paginationOptions.currentPage.toString()) + 1
    const config = {
      url: CORPORATES_ENDPOINT_PATH,
      params: {
        ...filters,
        page: page,
        limit: paginationOptions.limit,
      },
    }
    return await callApi<PagedResult<Corporate>>(config)
  }

  async function apiCreateCorporate(corporate: ApiCorporateData): Promise<Corporate> {
    return callApi<Corporate>({
      method: 'POST',
      url: CORPORATES_ENDPOINT_PATH,
      data: {
        ...corporate,
      },
    })
  }

  async function apiUpdateCorporate(id: EntityId, corporate: ApiCorporateData): Promise<Corporate> {
    return callApi<Corporate>({
      method: 'PUT',
      url: getUrlWithPathParams(CORPORATES_ENDPOINT_PATH, id),
      data: corporate,
    })
  }

  async function apiDeleteCorporate(corporateId: EntityId): Promise<void> {
    return callApi<void>({
      method: 'DELETE',
      url: getUrlWithPathParams(CORPORATES_ENDPOINT_PATH, corporateId),
    })
  }

  return {
    apiGetCorporate,
    apiGetCorporateList,
    apiDeleteCorporate,
    apiCreateCorporate,
    apiUpdateCorporate,
  }
}
